import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { QUIZ } from "@/data/content";
import { Reveal, Eyebrow } from "./Reveal";
import { QuizStep } from "./QuizStep";
import { ContactStep } from "./ContactStep";
import { ThankYou } from "./ThankYou";

const TOTAL = QUIZ.length + 1;
const initial = { pool_age: "", pool_type: "", problems: [], upgrades: [], timeframe: "" };

export const Funnel = () => {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState(initial);
  const [done, setDone] = useState(false);
  const current = QUIZ[step];

  const select = (opt) => {
    if (current.multi) {
      const list = answers[current.key];
      setAnswers({ ...answers, [current.key]: list.includes(opt) ? list.filter((o) => o !== opt) : [...list, opt] });
    } else {
      setAnswers({ ...answers, [current.key]: opt });
      setTimeout(() => setStep((s) => s + 1), 320);
    }
  };
  const canNext = current && (current.multi ? answers[current.key].length > 0 : !!answers[current.key]);
  const progress = done ? 100 : ((step + 1) / TOTAL) * 100;

  return (
    <section id="pool-check" data-testid="funnel-section" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal><Eyebrow>Pool-Check · kostenlos</Eyebrow></Reveal>
          <Reveal delay={0.08}><h2 className="mt-6 font-display text-4xl sm:text-5xl font-semibold leading-[1] tracking-[-0.03em]">Sechs Schritte zu Ihrem neuen Pool-Gefühl.</h2></Reveal>
          <Reveal delay={0.14}><p className="mt-6 text-[var(--mist)]">Beantworten Sie ein paar Fragen zu Ihrem Bestandspool. Wir melden uns anschließend persönlich mit einer ersten Einschätzung.</p></Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-8">
          <div data-testid="funnel-card" className="relative overflow-hidden rounded-[28px] border border-white/10 bg-[var(--deep)] p-6 sm:p-10">
            <div className="flex items-center justify-between font-mono text-xs uppercase tracking-[0.2em] text-[var(--mist)]">
              <span data-testid="funnel-step-indicator">{done ? "Fertig" : `Schritt ${step + 1} / ${TOTAL}`}</span>
              <span>{Math.round(progress)} %</span>
            </div>
            <div className="mt-4 h-1 w-full overflow-hidden rounded-full bg-white/10">
              <motion.div data-testid="funnel-progress" className="h-full bg-[var(--lagoon)]" animate={{ width: `${progress}%` }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }} />
            </div>
            <div className="mt-10 min-h-[380px]">
              {done ? <ThankYou /> : current ? (
                <QuizStep key={step} item={current} value={answers[current.key]} onSelect={select} />
              ) : (
                <ContactStep key="contact" answers={answers} onDone={() => setDone(true)} />
              )}
            </div>
            {!done && (
              <div className="mt-8 flex items-center justify-between border-t border-white/10 pt-6">
                <button data-testid="funnel-back-btn" disabled={step === 0} onClick={() => setStep((s) => s - 1)} className="inline-flex items-center gap-2 text-sm text-[var(--mist)] hover:text-[var(--foam)] disabled:opacity-30 transition-colors">
                  <ArrowLeft className="h-4 w-4" /> Zurück
                </button>
                {current && (
                  <button data-testid="funnel-next-btn" disabled={!canNext} onClick={() => setStep((s) => s + 1)} className="btn-primary disabled:opacity-40 disabled:pointer-events-none">
                    Weiter <ArrowRight className="h-4 w-4" />
                  </button>
                )}
              </div>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
